<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-md-offset-4 col-md-4">
            <card>
                <div class="header">
                    <h4 class="title">Troca de Senha</h4>
                </div>
                <div class="content">
                    <form @submit.prevent.stop='submit()'>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Senha</label>
                                    <input type="password" v-model="passwordChange.password" name='password' class="form-control border-input" required placeholder="Password">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Repita a Senha</label>
                                    <input type="password" v-model="passwordChange.repeat" name='repeat' class="form-control border-input" required placeholder="Password">
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-info btn-fill btn-wd">Enviar</button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                </div>
            </card>
        </div>
    </div>
</div>
</template>
<script>
import AuthService from '../services/auth-service'

export default {
  data () {
    return {
      passwordChange: {
        password: undefined,
        repeat: undefined,
        token: undefined
      }
    }
  },

  mounted () {
    this.passwordChange.token = this.$route.params.token
  },

  methods: {
    submit () {
      if (this.passwordChange.password !== this.passwordChange.repeat) {
        this.$alertify.error('Senhas não conferem!')
        return
      }

      AuthService.passwordReset(this.passwordChange).then(
        () => {
          this.$alertify.success('Senha alterada com sucesso!')
          window.location.href = '/'
        }).catch(
        er => {
          this.$alertify.error('Erro no servidor ao alterar senha')
        }
      )
    }
  }
}
</script>
